import { createSelector } from '../reselect';
import { getNewStats, total, simpleChart, simpleChart2, safeDivide } from '../generalUtils';

const influencerConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats.influencers, 'pixelConversionValue');
});

const influencerConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats.influencers, 'pixelConversionValue');
});

const influencerPurchases = createSelector([getNewStats], (stats) => {
  return total(stats.influencers, 'pixelPurchases');
});

const influencerPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats.influencers, 'pixelPurchases');
});

const influencerNcPurchases = createSelector([getNewStats], (stats) => {
  return total(stats.influencers, 'pixelNcPurchases');
});

const influencerNcPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats.influencers, 'pixelNcPurchases');
});

const influencerNcConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats.influencers, 'pixelNcConversionValue');
});

const influencerNcConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats.influencers, 'pixelNcConversionValue');
});

const influencerSpend = createSelector([getNewStats], (stats) => {
  return total(stats?.influencers, 'spend');
});

const influencerSpendChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats.influencers, 'spend');
});

const influencerRoas = createSelector([influencerConversionValue, influencerSpend], (cv, spend) =>
  safeDivide(cv, spend)
);
const influencerRoasChart = createSelector(
  [influencerConversionValueChart, influencerSpendChart],
  (cv, spend) => simpleChart2(cv, spend)
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    influencerConversionValue,
    influencerConversionValueChart,
    influencerSpend,
    influencerSpendChart,
    influencerRoas,
    influencerRoasChart,
    influencerPurchases,
    influencerPurchasesChart,
    influencerNcConversionValue,
    influencerNcConversionValueChart,
    influencerNcPurchases,
    influencerNcPurchasesChart,
  },
};
